import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { botConsoleGenerative } = config.endpoints

const getResourcesList = data => axios({
  method: 'POST',
  url: botConsoleGenerative.resourcesList,
  data,
  headers: getHeaders(true)
})

const addResource = data => axios({
  method: 'POST',
  url: botConsoleGenerative.addResource,
  data,
  headers: getHeaders(true)
})

const deleteResource = data => axios({
  method: 'POST',
  url: botConsoleGenerative.deleteResource,
  data,
  headers: getHeaders(true)
})

const hasUpdatedResources = id => axios({
  method: 'PUT',
  url: `${botConsoleGenerative.hasUpdatedResources}${id}`,
  data: { updatedDoc: true },
  headers: getHeaders(true)
})

export default {
  getResourcesList,
  addResource,
  deleteResource,
  hasUpdatedResources,
}
